<script>
import IngestionLoader from 'src/pages/inventory-ingestion-hub/components/ingestion-loader/index.vue';

export default {
    name: 'DrawerLoading',
    components: {
        IngestionLoader
    }
}
</script>

<template>
    <div class="drawer-loading">

        <div class="content-grid">
            <div class="col">
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
            </div>
            <div class="col">
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
                <IngestionLoader height="11px" width="240px" />
                <IngestionLoader height="11px" width="120px" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.drawer-loading {
    padding: 24px 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.header {
    padding-bottom: 16px;
    border-bottom: 1px solid var(--md-color--spirits--200);
}

.title-row {
    margin-bottom: 8px;
}

.status-row {
    margin-bottom: 12px;
}

.tabs {
    display: flex;
    gap: 24px;
    padding: 12px 0 20px 0;
    border-bottom: 1px solid var(--md-color--spirits--200);
    margin-bottom: 20px;
}

.content-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px 48px;
}

.col > *:not(:last-child) {
    display: block;
    margin-bottom: 16px;
}
</style>